<template>
    <div class="">
      <img class="bannerImg" src="@/assets/images/index/banner.png">
      <div class="parkDynamicContent">
        <div class="pageTitleContent">
          <div class="e-flex pageTitle">
            <img class="titleImg" src="@/assets/images/index/titleLeft.png">
            <div class="pageTitleText">园区动态</div>
            <img class="titleImg" src="@/assets/images/index/titleRight.png">
          </div>
          <div class="pageSubTitle">FUTURE SCIENCE CITY NEWS</div>
          <div class="e-flex viewMore" @click="goParkDynamics()">
            <div>查看更多</div>
            <img class="ic_right" src="@/assets/images/index/ic_right.png">
          </div>
        </div>
        <!-- <div class="e-flex">
          <div class="parkDynamicRight parkDynamicLeft_ml">
            <div v-for="(item, index) in parkDynamicList" v-if="index < 5" :class="'parkDynamicRightList e-flex ' + (index + 1 == 5 ? 'noBottomBorder' : '')" @click="goParkDynamic(item.id)">
              <div class="dateContent" style="min-width: 43px !important;">
                <div class="date">{{ item.publishDate.slice(8,10) }}</div>
                <div class="yearMonth">{{ item.publishDate.slice(0,7) }}</div>
              </div>
              <div class="parkDynamicRightCommon flexAll">{{ item.title }}</div>
            </div>
          </div>
          <div class="parkDynamicRight" v-if="parkDynamicList.length > 5">
            <div v-for="(item, index) in parkDynamicList" v-if="index >= 5 && index < 10" :class="'parkDynamicRightList e-flex ' + (index + 1 == 7 ? 'noBottomBorder' : '')" @click="goParkDynamic(item.id)">
              <div class="dateContent" style="min-width: 43px !important;">
                <div class="date">{{ item.publishDate.slice(8,10) }}</div>
                <div class="yearMonth">{{ item.publishDate.slice(0,7) }}</div>
              </div>
              <div class="parkDynamicRightCommon flexAll">{{ item.title }}</div>
            </div>
          </div>
          <div class="noDataContent" v-if="parkDynamicList.length == 0">
              <img class="noDataImg" src="@/assets/images/noDataImg.png">
              <div class="noDataText">暂无内容</div>
          </div>
        </div> -->
        <div class="pd_listContent mainpd_listContent">
          <div class="pd_listContentFlex" style="width: auto;">
            <div class="pd_list e-flex" style="justify-content: flex-start;" v-for="(item, index) in parkDynamicList" v-if="index % 2 == 0">
              <div class="pd_listWhite mainpd_listWhite" @click="goParkDynamic(item.id)">
                <div class="parkDynamicRightList e-flex bottomNone">
                  <div class="dateContent" style="min-width: 43px !important;">
                    <div class="date">{{ item.publishDate.slice(8,10) }}</div>
                    <div class="yearMonth">{{ item.publishDate.slice(0,7) }}</div>
                  </div>
                  <div class="parkDynamicRightCommon flexAll">{{ item.title }}</div>
                  <!-- <img class="parkDynamicRightImg" :src="item.thumbUrl"> -->
                </div>
              </div>
              <div class="pd_listWhite mainpd_listWhite e-flex pd_ml20" v-if="parkDynamicList[index + 1]" @click="goParkDynamic(parkDynamicList[index + 1].id)">
                <div class="parkDynamicRightList e-flex bottomNone">
                  <div class="dateContent" style="min-width: 43px !important;">
                    <div class="date">{{ parkDynamicList[index + 1].publishDate.slice(8,10) }}</div>
                    <div class="yearMonth">{{ parkDynamicList[index + 1].publishDate.slice(0,7) }}</div>
                  </div>
                  <div class="parkDynamicRightCommon flexAll">{{ parkDynamicList[index + 1].title }}</div>
                  <!-- <img class="parkDynamicRightImg" :src="list[index + 1].thumbUrl"> -->
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <div class="twoRegionContent">
        <div class="pageTitleContent">
          <div class="e-flex pageTitle">
            <img class="titleImg" src="@/assets/images/index/titleLeft.png">
            <div class="pageTitleText">两区政策</div>
            <img class="titleImg" src="@/assets/images/index/titleRight.png">
          </div>
          <div class="pageSubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
        <div class="e-flex twoRegionInfoContent">
          <div class="twoRegionLeft">
            <div class="twoRegionTitleContent e-flex">
              <img class="twoRegionTitleBorder" src="@/assets/images/index/titleLeft.png">
              <div class="twoRegionTitleText flexAll">通知公告</div>
              <div class="e-flex twoRegionMore" @click="goNotice()">
                <div>更多</div>
                <img class="twoRegionRight" src="@/assets/images/index/ic_right.png">
              </div>
            </div>
            <div v-for="(item, index) in noticeList" :class="'twoRegionList e-flex ' + (index == 4 ? 'noBottomBorder' : '')" @click="goNoticeDetail(item.id)">
              <img class="listPoint" src="@/assets/images/index/ic_listPoint.png">
              <div class="twoRegionListRight e-flex flexAll" >
                <div class="twoRegionListCommon e-line-1">{{ item.title }}</div>
                <div class="twoRegionDate">{{ item.publishDate.slice(5) }}</div>
              </div>
            </div>
            <div class="noDataContent1" v-if="noticeList.length == 0">
              <img class="noDataImg1" src="@/assets/images/noDataImg.png">
              <div class="noDataText1">暂无内容</div>
            </div>
          </div>
          <div class="twoRegionRightContent">
            <div class="twoRegionTitleContent e-flex" style="">
              <img class="twoRegionTitleBorder" src="@/assets/images/index/titleLeft.png">
              <div class="e-flex serviceTabs" style="justify-content: space-between;flex: 1">
                <div class="e-flex">
                  <div :class="'serviceTab ' + (serviceActiveName == 0 ? 'serviceTabActive' : '')" @click="searchService(0)">政策查询</div>
                  <div :class="'serviceTab ' + (serviceActiveName == 1 ? 'serviceTabActive' : '')" @click="searchService(1)">政策解读</div>
                </div>
                <div class="e-flex twoRegionMore" @click="getPolicyList()">
                  <div>查询</div>
                  <img class="twoRegionSearch" src="@/assets/images/index/ic_search.png">
                </div>
              </div>
            </div>
            <div class="twoRegionList e-flex" v-for="(item, index) in policyList" style="cursor: pointer;" @click="goServiceDetail(item)">
              <img class="listPoint" src="@/assets/images/index/ic_listPoint.png">
              <div class="twoRegionListRight e-flex flexAll">
                <div class="twoRegionListCommon e-line-1">{{ item.title }}</div>
                <div class="twoRegionDate">{{ item.publishDate.slice(5,10) }}</div>
              </div>
            </div>
            <div class="noDataContent1" v-if="policyList.length == 0">
              <img class="noDataImg1" src="@/assets/images/noDataImg.png">
              <div class="noDataText1">暂无内容</div>
            </div>
          </div>
        </div>
      </div>

      <div class="twoRegionActivityContent">
        <div class="pageTitleContent">
          <div class="e-flex pageTitle">
            <img class="titleImg" src="@/assets/images/index/titleLeft.png">
            <div class="pageTitleText">两区活动</div>
            <img class="titleImg" src="@/assets/images/index/titleRight.png">
          </div>
          <div class="pageSubTitle">FUTURE SCIENCE CITY NEWS</div>
          <div class="e-flex viewMore" @click="goTwoRegion()">
            <div>查看更多</div>
            <img class="ic_right" src="@/assets/images/index/ic_right.png">
          </div>
        </div>
        <div class="e-flex twoRegionActivityListContent">
          <div class="e-flex twoRegionActivityListCenter">
            <div v-for="(item,index) in regionActivityList" v-if="index < 4" @click="goTwoRegionActivity(item.id)"  :class="'activityList ' + (index != 0 ? 'activityList_ml' : '')">
              <img class="activityImg" :src="item.thumbUrl">
              <div class="activityCommon">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="noDataContent2" v-if="regionActivityList.length == 0">
          <img class="noDataImg2" src="@/assets/images/noDataImg.png">
          <div class="noDataText2">暂无内容</div>
        </div>
      </div>

      <div class="unionUnterprisesContent">
        <div class="pageTitleContent">
          <div class="e-flex pageTitle">
            <img class="titleImg" src="@/assets/images/index/titleLeft.png">
            <div class="pageTitleText colorWhite">企业联盟</div>
            <img class="titleImg" src="@/assets/images/index/titleRight.png">
          </div>
          <div class="pageSubTitle colorBlue">FUTURE SCIENCE CITY NEWS</div>
          <div class="e-flex viewMore viewMoreWhite colorWhite" @click="goCompany()">
            <div>查看更多</div>
            <img class="ic_right" src="@/assets/images/index/ic_rightWhite.png">
          </div>
        </div>
        <div class="e-flex unionTabContent">
          <div v-for="(item, index) in tabList" 
          :class="'unionTab ' + (index == 0 ? 'radiusLeft ' : ' ') + (index + 1 == tabList.length ? 'radiusRight ' : ' ') + (tabActive == index ? 'unionTabActive' : '')" @click="changeUnion(item, index)">{{ item.name }}</div>
        </div>
        <div class="e-flex moveContent" v-if="companyList.length != 0">
          <div class="tabChangeClick e-flex" @click="handel('prev')">
            <img class="tabChangeClickIcon" src="@/assets/images/index/tabLeft.png">
          </div>
          <div class="changeContent e-flex">
              <div class="changeListContent">
                <el-carousel :interval="5000" arrow="always" :autoplay="false" ref="carouse" :loop="false" indicator-position="none">
                  <el-carousel-item v-for="(item, index) in companyList" :key="index" v-if="index % 5 == 0">
                    <div class="e-flex">
                      <img class="unionLogo leftNone" :src="item.iconBigUrl" @click="goUnionEnterprisesDetail(item.id)">
                      <img class="unionLogo" v-if="companyList[index + 1]" :src="companyList[index + 1].iconBigUrl" @click="goUnionEnterprisesDetail(companyList[index + 1].id)">
                      <img class="unionLogo" v-if="companyList[index + 2]" :src="companyList[index + 2].iconBigUrl" @click="goUnionEnterprisesDetail(companyList[index + 2].id)">
                      <img class="unionLogo" v-if="companyList[index + 3]" :src="companyList[index + 3].iconBigUrl" @click="goUnionEnterprisesDetail(companyList[index + 3].id)">
                      <img class="unionLogo" v-if="companyList[index + 4]" :src="companyList[index + 4].iconBigUrl" @click="goUnionEnterprisesDetail(companyList[index + 4].id)">
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
          </div>
          <div class="tabChangeClick e-flex" @click="handel('next')">
            <img class="tabChangeClickIcon" src="@/assets/images/index/tabRight.png">
          </div>
        </div>
        <div class="noDataContent1" v-if="companyList.length == 0">
          <img class="noDataImg1" src="@/assets/images/noDataImg.png">
          <div class="noDataText1 noDataTextWhite">暂无内容</div>
        </div>
      </div>


      <div class="e-flex serviceAndInteract" style="background: #fff;">
        <div class="governmentAffairsServiceContent">
          <div class="pageTitleContent">
            <div class="e-flex pageTitle pageTitleLeft">
              <img class="titleImg" src="@/assets/images/index/titleLeft.png">
              <div class="pageTitleText">政务服务</div>
              <img class="titleImg" src="@/assets/images/index/titleRight.png">
            </div>
            <div class="pageSubTitle pageSubTitleLeft">FUTURE SCIENCE CITY NEWS</div>
            <div class="e-flex viewMore viewMoreHalf" @click="goService()">
              <div>更多</div>
              <img class="ic_right ic_rightHalf" src="@/assets/images/index/ic_right.png">
            </div>
          </div>
          <div class="e-flex governmentAffairsServiceListContent">
            <div v-for="(item, index) in serviceList" v-if="index < 5" :class="'governmentAffairsServiceBlock ' + (index == 0 ? 'ml-0' : '')" @click="goService(item.id)">
              <img class="ic_service" :src="item.iconUrl">
              <div class="serviceBlockText">{{item.name}}</div>
            </div>
            <div class="noDataContent1" v-if="serviceList.length == 0">
              <img class="noDataImg1" src="@/assets/images/noDataImg.png">
              <div class="noDataText1">暂无内容</div>
            </div>
          </div>
        </div>
        <div class="serviceInteractionContent">
          <div class="pageTitleContent ml-40">
            <div class="e-flex pageTitle pageTitleLeft">
              <img class="titleImg" src="@/assets/images/index/titleLeft.png">
              <div class="pageTitleText">互动服务</div>
              <img class="titleImg" src="@/assets/images/index/titleRight.png">
            </div>
            <div class="pageSubTitle pageSubTitleLeft">FUTURE SCIENCE CITY NEWS</div>
          </div>
          <div v-for="(item, index) in serviceDataList" v-if="index % 5 == 0"  :class="'serviceInteractionListContent e-flex ml-40 ' + (index == 0 ? 'serviceInteractionListContent1' : 'serviceInteractionListContent2')">
            <div class="serviceInteractionBlock ml-0 e-flex" @click="pgGovernmentAffairsServiceDetail(item.src)">
              <div class="serviceInteractionBlockText">{{ item.title.slice(0,12) }}</div>
            </div>
            <div class="serviceInteractionBlock e-flex" v-if="serviceDataList[index + 1]" @click="pgGovernmentAffairsServiceDetail(serviceDataList[index + 1].src)">
              <div class="serviceInteractionBlockText">{{ serviceDataList[index + 1].title.slice(0,12) }}</div>
            </div>
            <div class="serviceInteractionBlock e-flex" v-if="serviceDataList[index + 2]" @click="pgGovernmentAffairsServiceDetail(serviceDataList[index + 2].src)">
              <div class="serviceInteractionBlockText">{{ serviceDataList[index + 2].title.slice(0,12) }}</div>
            </div>
            <div class="serviceInteractionBlock e-flex" v-if="serviceDataList[index + 3]" @click="pgGovernmentAffairsServiceDetail(serviceDataList[index + 3].src)">
              <div class="serviceInteractionBlockText">{{ serviceDataList[index + 3].title.slice(0,12) }}</div>
            </div>
            <div class="serviceInteractionBlock e-flex" v-if="serviceDataList[index + 4]" @click="pgGovernmentAffairsServiceDetail(serviceDataList[index + 4].src)">
              <div class="serviceInteractionBlockText">{{ serviceDataList[index + 4].title.slice(0,12) }}</div>
            </div>
          </div>
          <div class="noDataContent1" v-if="serviceDataList.length == 0">
              <img class="noDataImg1" src="@/assets/images/noDataImg.png">
              <div class="noDataText1">暂无内容</div>
            </div>
        </div>
      </div>

      <div class="addFormContent">
        <div class="formTitle">企业人才诉求表单</div>
        <div class="formSubTitle">在线填写企业人才诉求表单的一些说明文字。</div>
        <div class="e-flex addFormBtnContent">
          <div class="e-flex addFormBtn" @click="goAppealForm()">
            <div>立即填写</div>
            <img class="ic_formRight" src="@/assets/images/index/ic_rightWhite.png">
          </div>
        </div>
      </div>
      
      <el-dialog title="" :visible.sync="loginVisible" width="12.916666666666666rem" :close-on-click-modal="false">
          <div class="e-flex loginFlex">
            <img class="loginImg" src="@/assets/images/loginImg.png" />
            <div>
              <div class="loginTitle">欢迎登录</div>
              <div class="controlEle e-flex">
                <el-input v-model="loginPhone" placeholder="输入手机号"></el-input>
              </div>
              <div class="controlEle e-flex">
                <el-input v-model="code" placeholder="输入验证码"></el-input>
                <div class="getcodeBtn" @click="getCode()">{{ codeName }}</div>
              </div>
              <div class="loginBtnDialog" @click="login()">登录</div>
            </div>
          </div>
          
        </el-dialog>
    </div>
  </template>
  
  <script>
    import '../../styles/index.css'
    import '../../styles/parkDynamics.css'
    export default {
      name: 'index',
      data () {
        return {
          policyElucidation: '',
          tabActive: 0,
          tabList: [],
          regionActivityList: [],
          parkDynamicList: [],
          noticeList: [],
          policyList: [],
          companyList: [],
          serviceList: [],
          serviceDataList: [{
            title: '外资商务服务业在京投资指引',
            src: 'https://open.beijing.gov.cn/front/getListIndex2021.do?nid=351'
          },{
            title: '“两区”外籍人才出入境事项服务',
            src: 'https://open.beijing.gov.cn/web/talentGuide/html/guidePage/guidePage.html'
          },{
            title: '外贸企业信息管理系统',
            src: 'https://open.beijing.gov.cn/web/userCenter/#/login'
          },{
            title: '外资企业诉求服务',
            src: 'https://open.beijing.gov.cn/web/operateStatus/#/Loginquery'
          },{
            title: '商务服务业发展地图',
            src: 'https://open.beijing.gov.cn/web/industry-analyze/#/show/map'
          },{
            title: '核发外商来华邀请函',
            src: 'http://service.sw.beijing.gov.cn/yqh/front/sww.do?login'
          },{
            title: '京企“走出去”综合服务系统',
            src: 'https://beijing.investgo.cn/'
          },{
            title: '北京投资地图',
            src: 'http://map.invest.beijing.gov.cn/'
          },{
            title: '政民互动',
            src: 'https://sw.beijing.gov.cn/zmhd/'
          },{
            title: '政府网站年报',
            src: 'https://open.beijing.gov.cn/front/getListIndex2021.do?nid=310'
          }],
          serviceActiveName: '0',
          user: '',
          loginVisible: false,
          loginPhone: '',
          code: '',
          codeName: '获取验证码',
          n: 180,
        }
      },
      created() {
        console.log(this.user)
        this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : ''
        this.getParkDynamic()
        this.getRegionActivity()
        this.getNotice()
        this.getPolicy(0)
        this.getCompanyType()
        this.getServiceType()
        // this.getService()
      },
      methods: {
        changeUnion(item, index) {
          this.tabActive = index
          this.getCompanyType()
        },
        handel(row) {
          if (row == 'next') {
            this.$refs.carouse.next()
          } else {
            this.$refs.carouse.prev()
          }
        },
        goParkDynamic(id) {
          this.$router.push({ path: '/parkDynamics/detail', query: {from: 1,id: id}})
        },
        goTwoRegionActivity(id) {
          this.$emit('goNavPage', {
            key:'5',
            path: ['5']
          })
          this.$router.push({ path: '/twoRegionActivity/detail', query: {id: id}})
        },
        goParkDynamics() {
          this.$emit('goNavPage', {
            key:'2',
            path: ['2']
          })
          this.$router.push({ path: '/parkDynamics/index', query: {}})
        },
        goTwoRegion() {
          this.$emit('goNavPage', {
            key:'5',
            path: ['5']
          })
          this.$router.push({ path: '/twoRegionActivity/index', query: {}})
        },
        goCompany() {
          this.$emit('goNavPage', {
            key:'9',
            path: ['9']
          })
          this.$router.push({ path: '/unionEnterprises/index', query: {}})
        },
        goNotice() {
          this.$emit('goNavPage', {
            key:'43',
            path: ['43'],
            subMenu: '4'
          })
          this.$router.push({ path: '/twoRegionPolicy/twoRegionPolicyAnnouncement', query: {}})
        },
        goNoticeDetail(id) {
          // this.$emit('goNavPage', {
          //   key:'43',
          //   path: ['43'],
          //   subMenu: '4'
          // })
          this.$router.push({ path: '/twoRegionPolicy/twoRegionPolicyAnnouncementDetail', query: {id: id}})
        },
        goService(id) {
          this.$emit('goNavPage', {
            key:'6',
            path: ['6']
          })
          this.$router.push({ path: '/governmentAffairsService/index', query: {id: id}})
        },
        getPolicyList() {
          console.log('this.serviceActiveName',this.serviceActiveName)
          let url = this.serviceActiveName == 0 ? '/twoRegionPolicy/twoRegionPolicySearch' : 'twoRegionPolicy/policyInterpretation'
          let keyStr = this.serviceActiveName == 0 ? '41' : '42'
          this.$emit('goNavPage', {
            key:keyStr,
            path: [keyStr],
            subMenu: '4'
          })
          this.$router.push({ path: url, query: {}})
        },
        goServiceDetail(item) {
          let url = item.type == 0 ? '/twoRegionPolicy/regionPolicyDetail' : '/twoRegionPolicy/policyInterpretationDetail'
          this.$router.push({ path: url, query: {id: item.id}})
        },
        goUnionEnterprisesDetail(id) {
          this.$router.push({ path: '/unionEnterprises/unionEnterprisesDetail', query: {id: id}})
        },
        pgGovernmentAffairsServiceDetail(src) {
          window.open(src)
          // this.$router.push({ path: '/governmentAffairsService/governmentAffairsServiceDetail', query: {id: id}})
        },
        getRegionActivity() {
          this.request({
              url: 'activity/list?page=1&limit=6',
              method: 'get',
              data: {}
          }).then(res => {
              this.regionActivityList = res.data
          })
        },
        goAppealForm() {
          console.log(this.user)
          if (this.user) {
            this.$router.push({ path: '/appeal/appealForm', query: {}})
          } else {
            this.loginVisible = true
          }
        },
        getParkDynamic() {
          this.request({
              url: 'info/list?page=1&limit=10',
              method: 'get',
              data: {}
          }).then(res => {
              this.parkDynamicList = res.data
          })
        },
        getNotice() {
          this.request({
              url: 'notice/list?page=1&limit=5',
              method: 'get',
              data: {}
          }).then(res => {
              this.noticeList = res.data
          })
        },
        getPolicy(type) {
          this.request({
              url: 'policy/list',
              method: 'POST',
              data: {
                page:1,
                limit:5,
                type: type
              }
          }).then(res => {
              this.policyList = res.data
          })
        },
        getCompanyType() {
          this.request({
              url: 'companyLeague/typeList?page=1&limit=99',
              method: 'get',
              data: {}
          }).then(res => {
              this.tabList = res.data
              this.getCompanyLeague()
          })
        },
        getCompanyLeague() {
          this.request({
              url: 'companyLeague/list?page=1&limit=99&typeId=' + this.tabList[this.tabActive].id,
              method: 'get',
              data: {}
          }).then(res => {
              this.companyList = res.data
          })
        },
        getServiceType() {
          this.request({
              url: 'governmentService/queryCategoryAllList',
              method: 'POST',
              data: {}
          }).then(res => {
              this.serviceList = res.data
          })
        },
        getService() {
          this.request({
              url: 'governmentService/list',
              method: 'POST',
              data: {
                page: 1,
	              limit: 10,
                status:1
              }
          }).then(res => {
              this.serviceDataList = res.data
          })
        },
        serviceHandleClick(e) {
          console.log(e)
        },
        searchService(serviceType) {
          this.serviceActiveName = serviceType
          this.getPolicy(serviceType)
        },
        getCode() {
          if (!this.loginPhone) {
            this.$message({
              message: '请填写手机号',
              type: 'warning',
              iconClass: 'none'
            });
            return
          }
          if (this.codeName != '获取验证码') {
            this.$message({
              message: '请勿重复获取',
              type: 'warning',
              iconClass: 'none'
            });
            return
          }
          this.request({
              url: 'user/getCode',
              method: 'POST',
              data: {
                mobile: this.loginPhone
              }
          }).then(res => {
              if (res.code == 1) {
                this.$message({
                    message: '验证码已发送',
                    type: 'success',
                    iconClass: 'none'
                });
                if (this.n >= 0) {
                  this.codeName = this.n + ' s'
                  let interval = setInterval(() => {
                    if (this.n == 0) {
                      this.codeName = '获取验证码'
                      this.n = 180
                      clearInterval(interval)
                      return
                    }
                    this.n = this.n - 1
                    this.codeName = this.n + ' s'
                  },1000)
                } else {
                  this.codeName = '获取验证码'
                }
              }
          })
        },
        login() {
          this.request({
              url: 'user/login',
              method: 'POST',
              data: {
                mobile:this.loginPhone,
                code:this.code
              }
          }).then(res => {
            if (res.code == 1) {
              localStorage.setItem('user', JSON.stringify(res.data));
              this.user = res.data
              this.loginVisible = false
              this.$emit('pageLogin', {})
              this.$router.push({ path: '/appeal/appealForm', query: {}})
            }
          })
        },
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/index/index.vue